module.exports = __webpack_public_path__ + "img/Logo_CMYK_Outline.5075559d.jpg";